// Shared constants for the maker-checker payload renderers.

export const PAYLOAD_VERSION = {
  LEGACY: 0, // payload/updated_payload are flat + frontend-shaped (rows created before the keyed model)
  KEYED: 1,  // payload/updated_payload/payload_difference are keyed by table name
};

export const isKeyedPayload = (action) => Number(action?.payload_version) === PAYLOAD_VERSION.KEYED;

// Never render these, whichever model the row uses.
export const HIDDEN_KEYS = ["password", "fp_array", "token", "secret", "created_date"];

export const isPlainObject = (v) => v !== null && typeof v === "object" && !Array.isArray(v);

// ref_table_name -> human label for the group heading of a comparison table.
export const TABLE_LABELS = {
  b2b_team: "B2B Team",
  content_writer: "Content Writer",
  designer: "Designer",
  legal_team: "Legal Team",
  finance_team: "Finance Team",
  sales_persons: "Sales Person",
  advertisers: "Advertiser",
  company: "Company",
  classified_users: "Classified User",
  lineitems: "Line Item",
  audience_targets: "Audience Target",
  adunit_pos_slot_status: "Ad Unit Slot Status",
  birdview_brands: "Birdview Brand",
  alpha_ads_brands: "Alpha Brand",
  local_ads_positional_price: "Local Card List",
  alpha_ads_panel_positional_price: "Alpha Card List",
  classified_ads_positional_price: "Classified Card List",
  local_package_panel_positional_price: "Local Package Card List",
  zone_package_positional_price: "Zone Package Card List",
};

export const tableLabel = (table) => TABLE_LABELS[table] || table || "Details";

/*
 * Display name for list rows / headings, resolved across BOTH payload models.
 * Mirrors resolveDisplayName() on the API side.
 *   legacy (v0): flat on payload  ->  payload.name
 *   keyed  (v1): payload is keyed by table, so the name lives on request_payload
 *                (what the maker submitted) or nested under payload[<table>].
 * Without this, v1 rows render "N/A" in every list.
 */
export const resolveDisplayName = (action, key = "name") => {
  const request = action?.request_payload;
  if (isPlainObject(request) && request[key] != null) return request[key];

  const payload = action?.payload;
  if (isPlainObject(payload)) {
    if (payload[key] != null) return payload[key]; // legacy flat
    for (const value of Object.values(payload)) {
      if (isPlainObject(value) && value[key] != null) return value[key]; // keyed
    }
  }

  const updated = action?.updated_payload;
  if (isPlainObject(updated) && updated[key] != null) return updated[key];
  return "";
};

// First non-empty display label for a row: name, else campaign_name, else brand_name.
export const resolveRowLabel = (action) =>
  resolveDisplayName(action, "name") ||
  resolveDisplayName(action, "campaign_name") ||
  resolveDisplayName(action, "brand_name") ||
  "N/A";

// Turns snake_case DB columns into readable field labels.
export const fieldLabel = (field = "") =>
  String(field)
    .split(".")
    .map((part) =>
      part
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase())
    )
    .join(" › ");
